import { AiOutlineCheck, AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import {FaBox, FaCog, FaStore, FaTimes, FaUsers} from 'react-icons/fa';
import { type Agency } from '../../../common/types';
import { HiBuildingOffice2 } from 'react-icons/hi2';
import { Link } from 'react-router-dom';

interface IProps {
  item: Agency;
  toggleEditModal: () => any;
  toggleDeleteModal: () => any;
  toggleApproveModal: () => any;
  handleEditingItem: (item: Agency) => any;
  handleDeletingItem: (item: Agency) => any;
  handleApprovingItem: (item: Agency) => any;
}

const ListAgencyItem: React.FC<IProps> = ({
  item,
  toggleEditModal,
  toggleDeleteModal,
  toggleApproveModal,
  handleEditingItem,
  handleDeletingItem,
  handleApprovingItem
}) => {
  const statusValue = item.isActive ? 'Active' : 'Inactive';
  const statusClasses = item.isActive ? 'text-green-400' : 'bg-red-500 rounded-lg bg-opacity-90';

  const editItemHandler = (): void => {
    toggleEditModal();
    handleEditingItem(item);
  };

  const deleteItemHandler = (): void => {
    toggleDeleteModal();
    handleDeletingItem(item);
  };

  const approveItemHandler = (): void => {
    toggleApproveModal();
    handleApprovingItem(item);
  };

  return (
    <tr className="odd:bg-white even:bg-gray-50" key={item.id}>
      <td className="p-2 pl-8 text-sm text-gray-700 whitespace-nowrap">
        <div className="flex flex-col">
          <Link to={`/admin/agencies/${item.id}`} className="hover:text-[#1D8A43] flex space-x-2">
            <span>{item.name}</span>
          </Link>
          <div className="flex">
            <span className="text-xs text-gray-400">{item.email.toLowerCase()}</span>
            {item.isApproved ? <AiOutlineCheck size={12} color="green" /> : <FaTimes size={12} color="red" />}
          </div>
        </div>
      </td>
      <td className="p-2 text-sm text-gray-700 whitespace-nowrap">{item.identifier}</td>
      <td className="p-2 text-sm text-gray-700 whitespace-nowrap">{item.address}</td>
      <td className="p-2 text-sm text-gray-700 whitespace-nowrap">{item.phone}</td>
      <td className="p-2 text-sm text-gray-700 whitespace-nowrap">
        <span className={`p-1.5 text-xs font-medium text-gray-700 ${statusClasses}`}>{statusValue}</span>
      </td>
      <td className="p-2 pr-8 text-sm text-left text-gray-700 whitespace-nowrap">
        <div className="flex flex-row items-center space-x-3">
          {item.isApproved && (
            <>
              <Link to={`/admin/agencies/${item.id}/merchants`}>
                <span className="px-1 h-full">
                  <HiBuildingOffice2 color="green" size={18} />
                </span>
              </Link>
              <Link to={`/admin/agencies/${item.id}/stores`}>
                <span className="px-1 h-full">
                  <FaStore color="green" size={18} />
                </span>
              </Link>
              <Link to={`/admin/agencies/${item.id}/devices`}>
                <span className="px-1 h-full">
                  <FaBox size={18} />
                </span>
              </Link>
              <Link to={`/admin/agencies/${item.id}/users`}>
                <span className="px-1 h-full">
                  <FaUsers color="green" size={18} />
                </span>
              </Link>
              <Link to={`/admin/configurations/agency/${item.id}`}>
                <span className="px-1 h-full">
                  <FaCog size={18} />
                </span>
              </Link>
              <button data-cy="edit-agency-btn">
                <span className="px-1 h-full">
                  <AiOutlineEdit color="blue" size={18} onClick={editItemHandler} />
                </span>
              </button>
            </>
          )}
          {!item.isApproved && (
            <button>
              <span className="px-1 h-full">
                <AiOutlineCheck color="green" size={18} onClick={approveItemHandler} />
              </span>
            </button>
          )}
          <button
            data-cy="delete-agency-btn"
            onClick={deleteItemHandler}
            className="text-gray-50 text-sm text-center rounded-md"
          >
            <span className="px-1 h-full">
              <AiOutlineDelete color="red" size={18} />
            </span>
          </button>
        </div>
      </td>
    </tr>
  );
};

export default ListAgencyItem;
